var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useCallback, useEffect, useMemo, useState } from "react";
import { getEmailSendLogAPI, getEmailSendLogExportAPI, } from "../../../resources/helper/emailSendLog";
import { certificateFromEmailSendLog, mapEmailSendLogToMailHistory, } from "../resources/mailHistoryMapper";
import { downloadMailHistoryExcel } from "../resources/mailHistoryExport";
import { showErrorToast } from "../../../fnx/showError";
var triggerBlobDownload = function (blob, filename) {
    var url = URL.createObjectURL(blob);
    var link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
};
/**
 * Historial de envío de correos de una póliza: consulta la bitácora del servicio
 * de notificaciones y la convierte en los envíos que muestra el tab.
 */
export var useMailHistory = function (_a) {
    var policyId = _a.policyId, _b = _a.enable, enable = _b === void 0 ? true : _b, setSeeToast = _a.setSeeToast, t = _a.t;
    var _c = useState([]), rawEntries = _c[0], setRawEntries = _c[1];
    var _d = useState(false), loadingMailHistory = _d[0], setLoadingMailHistory = _d[1];
    var fetchMailHistory = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!enable || !policyId) {
                        setRawEntries([]);
                        return [2 /*return*/];
                    }
                    setLoadingMailHistory(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, getEmailSendLogAPI(policyId)];
                case 2:
                    response = _a.sent();
                    setRawEntries(Array.isArray(response === null || response === void 0 ? void 0 : response.data) ? response.data : []);
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    setRawEntries([]);
                    showErrorToast({
                        errors: (error_1 === null || error_1 === void 0 ? void 0 : error_1.errors) || [],
                        message: (error_1 === null || error_1 === void 0 ? void 0 : error_1.message) ||
                            "No se pudo cargar el historial de correos. Intente nuevamente.",
                    }, setSeeToast, t, true);
                    return [3 /*break*/, 5];
                case 4:
                    setLoadingMailHistory(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [enable, policyId, setSeeToast, t]);
    useEffect(function () {
        fetchMailHistory();
    }, [fetchMailHistory]);
    var mailHistoryItems = useMemo(function () { return mapEmailSendLogToMailHistory(rawEntries); }, [rawEntries]);
    var mailHistoryLogCertificate = useMemo(function () { return certificateFromEmailSendLog(rawEntries); }, [rawEntries]);
    /**
     * Descarga el Excel que genera el backend. Si el servicio falla se arma el
     * archivo con los envíos ya cargados para no dejar al usuario sin el reporte.
     */
    var downloadMailHistory = useCallback(function (items, certificate, printedAt) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, blob, filename, error_2;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!policyId)
                        return [2 /*return*/];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, getEmailSendLogExportAPI(policyId)];
                case 2:
                    _a = _b.sent(), blob = _a.blob, filename = _a.filename;
                    triggerBlobDownload(blob, filename || "historial-correos-".concat(certificate || "poliza", ".xlsx"));
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _b.sent();
                    showErrorToast({
                        errors: (error_2 === null || error_2 === void 0 ? void 0 : error_2.errors) || [],
                        message: (error_2 === null || error_2 === void 0 ? void 0 : error_2.message) ||
                            "No se pudo descargar el historial desde el servicio; se generó una copia local.",
                    }, setSeeToast, t, true);
                    downloadMailHistoryExcel(items, certificate, printedAt);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [policyId, setSeeToast, t]);
    return {
        mailHistoryItems: mailHistoryItems,
        mailHistoryLogCertificate: mailHistoryLogCertificate,
        loadingMailHistory: loadingMailHistory,
        downloadMailHistory: downloadMailHistory,
        refetchMailHistory: fetchMailHistory,
    };
};
